import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Dot } from "lucide-react";

import { cn } from "@/lib/utils";

const RadioButton = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-full border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      "data-[state=checked]:bg-brand-secondary data-[state=checked]:border-brand-secondary",
      className
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Dot className="h-2 w-2" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));
RadioButton.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioButton };